export default {
    props: {
        offset: {
            type: Array,
            default: () => [ 0.5 ],
        },
    },
    methods: {
        observe() {
            if (this.$options.observer != null)
                return;

            const options = {
                rootMargin: '0px',
                threshold: this.offset,
            };

            const handler = ([ entry ]) => {
                const threshold = this.offset[0] ?? 0;
                if (entry.intersectionRatio < threshold)
                    return;

                const active = '#' + entry.target.id;
                if (entry.isIntersecting) {
                    this.active = active;
                } else {
                    if (entry.target.getBoundingClientRect().top < 0) {
                        this.active = active;
                    }
                }
            };

            const observer = new IntersectionObserver(handler, options);

            for (const it of this.itemList) {
                const target = this.$refs.section.querySelector(it.hash);
                if (target) {
                    observer.observe(target);
                }
            }
        },
    },
};
